import {Directive, forwardRef} from '@angular/core';
import {NG_VALIDATORS} from '@angular/forms';
import {validateIdentityCardNumber} from '@atlas/businesstypes';

import {AbstractValidatorDirective} from '../base/validator';

/**
 * @ngModule BusinessTypesModule
 */
@Directive({
  selector: '[atlasIdentityCardNumber]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BaseIdentityCardNumberValidator),
      multi: true,
    },
  ],
})
export class BaseIdentityCardNumberValidator extends AbstractValidatorDirective {
  protected readonly validatorFn = validateIdentityCardNumber;
}
